import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const features = ['+240 páginas de contenido estructurado', '60+ clases completas listas para dar', 'Evaluación · Movilidad · Fuerza · Equilibrio · Clases Grupales · Patologías', 'Planificación · Variaciones · Fidelización · Comunicación', 'Funciona desde hoy mismo en tu centro, club o consultorio'];
const tags = ['Principiante', 'Intermedio', 'Avanzado', 'Movilidad Funcional', 'Fuerza Adaptada', 'Prevención de Caídas'];
export function ProductReveal() {
  return <section className="py-10 md:py-20 px-4 bg-navy-900 text-white relative overflow-hidden" data-id="element-236">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#D4A537 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-237"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-238">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6 md:mb-12" data-id="element-239">
          <p className="text-gold font-bold tracking-widest text-sm mb-4 uppercase" data-id="element-240">
            SISTEMA N°1 PARA PROFES Y KINESIÓLOGOS QUE TRABAJAN CON ADULTOS
            MAYORES EN ARGENTINA
          </p>
          <h2 className="font-display text-5xl md:text-7xl text-white mb-4 tracking-wide" data-id="element-241">
            RECURSOSFITNESS™ <br data-id="element-242" />
            <span className="text-gold" data-id="element-243">MEGAPACK FUERZA MAYOR</span>
          </h2>
          <p className="text-xl md:text-2xl text-navy-100 font-medium max-w-3xl mx-auto" data-id="element-244">
            SISTEMA COMPLETO — 6 Tomos + 6 Bonos — Todos los niveles — Todo
            resuelto.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center bg-navy-800 p-8 md:p-12 rounded-2xl border border-navy-700 shadow-2xl" data-id="element-245">
          <div className="space-y-6" data-id="element-246">
            {features.map((feature, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="flex items-start gap-3" data-id="element-247">
                <CheckCircle2 className="text-gold shrink-0 mt-1" size={24} data-id="element-248" />
                <p className="text-lg text-navy-50" data-id="element-249">{feature}</p>
              </motion.div>)}
          </div>

          <div data-id="element-250">
            <h3 className="text-gold font-bold mb-6 text-lg uppercase tracking-wider border-b border-navy-700 pb-2" data-id="element-251">
              Niveles y enfoques incluidos:
            </h3>
            <div className="flex flex-wrap gap-3" data-id="element-252">
              {tags.map((tag, idx) => <motion.span key={idx} initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: idx * 0.05
            }} className="bg-navy-700 text-navy-50 px-4 py-2 rounded-full text-sm font-medium border border-navy-600" data-id="element-253">
                  {tag}
                </motion.span>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}